export default __webpack_public_path__ + "static/media/Throat.c8477a15.png";